import { render } from "./LoanSatker.vue?vue&type=template&id=2a52eda4"
import script from "./LoanSatker.vue?vue&type=script&lang=js"
export * from "./LoanSatker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__